import * as React from "react";

import { useKonamiCode } from "../hooks";
import { isMockEnabled, setMockEnabled } from "../lib/mock";
import { toaster } from "./toaster";

// Listens for the Konami code and toggles mock API mode, then reloads so
// the new mode takes effect on the next data fetch.
export default function MockModeToggle(): null {
  const onUnlock = React.useCallback(() => {
    const enabled = !isMockEnabled();
    setMockEnabled(enabled);
    toaster.create({
      type: "info",
      title: enabled ? "Mock data enabled" : "Mock data disabled",
    });
    window.setTimeout(() => window.location.reload(), 1000);
  }, []);

  useKonamiCode(onUnlock);
  return null;
}
